<template>
  <v-app v-resize="onResize">
    <v-navigation-drawer width="190" v-model="sidebar" app dark>
      <v-list>
        <v-list-item
          v-for="item in roleBasedMenuItems"
          :key="item.title"
          :to="item.path"
        >
          <v-list-item-action>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-hover v-slot:default="{ hover }">
      <v-app-bar
        :src="menubarImage.url"
        app
        :dense="!showNavbar && !sidebar"
        dark
        shrink-on-scroll
        prominent
      >
        <template v-slot:img="{ props }">
          <v-img
            v-bind="props"
            :gradient="
              'to bottom, rgba(255,255,255,0.0), rgba(0,0,0,' +
              menubarImage.gradient +
              ')'
            "
          ></v-img>
        </template>
        <v-dialog
          v-model="showBannerDialog"
          @keydown.enter="saveBanner()"
          @keydown.esc="showBannerDialog = false"
          max-width="850px"
        >
          <v-card>
            <v-card-title> Change banner image </v-card-title>
            <v-card-text>
              <v-container grid-list-sm>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      autofocus
                      v-model="menubarImage.url"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      label="Gradient"
                      v-model="menubarImage.gradient"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      label="Copyright"
                      v-model="menubarImage.copyright"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      label="Text Color"
                      v-model="menubarImage.textcolor"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="showBannerDialog = false">Cancel</v-btn>
              <v-btn small color="primary" @click="saveBanner()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-app-bar-nav-icon
          class="hidden-sm-and-up"
          @click="sidebar = !sidebar"
        />
        <v-toolbar-title class="text-h6">
          <v-btn
            text
            ripple
            small
            @click="showBannerDialog = true"
            v-if="hover && $store.state.roles.includes('webmaster')"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-sheet dark color="rgb(0,0,0,.3)">
            <v-img
              width="300"
              src="/images/1594510858.8041-NCPSLogo.png"
            >
            </v-img>
          </v-sheet>
        </v-toolbar-title>
        <v-spacer />
        <div :class="menubarImage.textcolor + '--text caption mt-1'">
          {{ menubarImage.copyright }}
        </div>
        <v-toolbar-items
          v-if="!showNavbar && !sidebar"
          slot="extension"
          class="hidden-xs-only"
        >
          <v-menu offset-y>
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                SiteMap
              </v-btn>
            </template> -->
            <v-list>
              <v-list-item
                v-for="(item, index) in $store.state.meetingInfo.prettyBoxes"
                :key="index"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            slot="extension"
            text
            ripple
            small
            :color="item.color"
            v-for="item in roleBasedMenuItems"
            :key="item.title"
            :to="item.path"
          >
            <v-icon class="hidden-sm-and-down">{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-btn>
        </v-toolbar-items>
      </v-app-bar>
    </v-hover>

    <v-main>
      <router-view class="pa-0" />
    </v-main>

    <v-footer color="rgb(200,200,200)" inset app absolute>
      <div class="font-weight-thin font-italic caption">
        This website and its content is copyright &copy;
        {{ new Date().getFullYear() }} North County Photographic Society. All
        rights reserved. Use of content, graphics, and logos is strictly
        prohibited without prior written permission.
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import axios from "axios";
import { TokenService } from "@/services/storage.service";

export default {
  data: () => {
    return {
      meetingInfo: {},
      sidebar: false,
      menubarImage:
        "/images/1593987051.9247-HOME%20PAGE%20-%20Swami's%20with%20©.jpg",
      showNavbar: false,
      showBannerDialog: false,
      item: {},
      menuItems: [
        { title: "Home", path: "/", icon: "camera", role: "", color: "" },
        {
          title: "Galleries",
          path: "/galleries/0",
          icon: "photo_library",
          role: "",
          color: "",
        },
        {
          title: "Photo Shoots",
          path: "/photoshoots",
          icon: "photo_album",
          role: "",
          color: "",
        },
        {
          title: "Newsletter",
          path: "/newsletters",
          icon: "dashboard",
          role: "",
          color: "",
        },
        {
          title: "Calendar",
          path: "/calendar",
          icon: "event",
          role: "",
          color: "",
        },
        {
          title: "Members",
          path: "/membership",
          icon: "group",
          role: "membership",
          color: "",
        },
        {
          title: "Members",
          path: "/membership",
          icon: "group",
          role: "ro_member",
          color: "",
        },
        {
          title: "Files",
          path: "/files",
          icon: "description",
          role: "webmaster",
          color: "",
        },
        {
          title: "Sign In",
          path: "/signin",
          icon: "fingerprint",
          role: "",
          color: "",
        },
        // {
        //   title: "SiteMap",
        //   path: "/sitemap",
        //   icon: "help",
        //   role: "",
        //   color: "",
        // },
        {
          title: "Help",
          path: "/info/help",
          icon: "help",
          role: "",
          color: "",
        },
      ],
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth >= 600) {
        this.showNavbar = false;
      } else {
        this.showNavbar = true;
      }
    },
    saveBanner() {
      var bodyFormData = new FormData();
      bodyFormData.append("Username", TokenService.getUsername());
      bodyFormData.append("token", TokenService.getToken());
      bodyFormData.append("id", this.menubarImage.id);
      bodyFormData.append("url", this.menubarImage.url);
      bodyFormData.append("copyright", this.menubarImage.copyright);
      bodyFormData.append("gradient", this.menubarImage.gradient);
      bodyFormData.append("textcolor", this.menubarImage.textcolor);
      axios
        .post(
          process.env.VUE_APP_WEBSITE + "/memberlogin2/api_updatebanner.php",
          bodyFormData
        )
        .then(
          (response) => {
            if (response.data.error === "Wrong username or password") {
              alert("You do not have privileges to make changes");
            } else {
              this.showBannerDialog = false;
            }
          },
          function (error) {
            alert("Save banner:" + error);
          }
        );
    },
  },
  watch: {
    // eslint-disable-next-line
    "$store.state.loggedIn"(to, from) {
      if (to === true) {
        this.menuItems[8].title = "Signed In";
        // this.menuItems[8].color = 'success'
      } else {
        this.menuItems[8].title = "Sign In";
        // this.menuItems[8].color = 'info'
      }
    },
    "$store.state.meetingInfo"(to) {
      this.meetingInfo = to;
    },

    //  As soon as we've finished downloading all the banner paths, update the menu bar image
    "$store.state.banners"() {
      this.menubarImage = this.$store.state.banners[this.$route.path];
    },
    // eslint-disable-next-line
    $route(to) {
      // react to route changes...
      if (typeof this.$store.state.banners[to.path] !== "undefined") {
        this.menubarImage = this.$store.state.banners[to.path];
      }
    },
  },
  computed: {
    appTitle() {
      return this.$store.state.appTitle;
    },
    roles() {
      return this.$store.state.roles;
    },
    roleBasedMenuItems() {
      var roleMatches = [];
      this.menuItems.forEach((element) => {
        if (this.roles.includes(element.role)) {
          roleMatches.push(element);
        }
      });
      return roleMatches;
    },
  },
};
</script>
